angular.module('components.media.VideoService', [
  'global'
])

/**
 * The VideoService service handles scoring and
 * feedback for the state.contentView type
 *
 * @class VideoService
 * @constructor
 * @module components.media.VideoService
 */
.factory('VideoService', [
  function () {
    'use strict';

    var service = {
    };

    return service;
  }
]);
